import IconBase from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

/**
 * 
 * 
 <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.4458 12.0005L9.37252 7.9275C9.23419 7.789 9.16336 7.61492 9.16002 7.40525C9.15686 7.19575 9.22769 7.0185 9.37252 6.8735C9.51752 6.72867 9.69319 6.65625 9.89952 6.65625C10.1059 6.65625 10.2815 6.72867 10.4265 6.8735L14.9208 11.3678C15.0143 11.4614 15.0803 11.5602 15.1188 11.664C15.1573 11.7678 15.1765 11.88 15.1765 12.0005C15.1765 12.121 15.1573 12.2332 15.1188 12.337C15.0803 12.4408 15.0143 12.5396 14.9208 12.6333L10.4265 17.1275C10.288 17.2658 10.1139 17.3367 9.90427 17.34C9.69477 17.3432 9.51752 17.2723 9.37252 17.1275C9.22769 16.9825 9.15527 16.8068 9.15527 16.6005C9.15527 16.3942 9.22769 16.2185 9.37252 16.0735L13.4458 12.0005Z" fill="#1D2225"/>
</svg>


 */
const KeyboardArrowRight = ({ ...props }: IconProps) => {
  return (
    <IconBase
      width={props.width}
      height={props.height}
      viewBox="0 0 25 24"
      fill={props.fill}
      xmlns="http://www.w3.org/2000/svg"
      paths={[
        {
          d: 'M13.4458 12.0005L9.37252 7.9275C9.23419 7.789 9.16336 7.61492 9.16002 7.40525C9.15686 7.19575 9.22769 7.0185 9.37252 6.8735C9.51752 6.72867 9.69319 6.65625 9.89952 6.65625C10.1059 6.65625 10.2815 6.72867 10.4265 6.8735L14.9208 11.3678C15.0143 11.4614 15.0803 11.5602 15.1188 11.664C15.1573 11.7678 15.1765 11.88 15.1765 12.0005C15.1765 12.121 15.1573 12.2332 15.1188 12.337C15.0803 12.4408 15.0143 12.5396 14.9208 12.6333L10.4265 17.1275C10.288 17.2658 10.1139 17.3367 9.90427 17.34C9.69477 17.3432 9.51752 17.2723 9.37252 17.1275C9.22769 16.9825 9.15527 16.8068 9.15527 16.6005C9.15527 16.3942 9.22769 16.2185 9.37252 16.0735L13.4458 12.0005Z',
        },
      ]}
      {...props}
    ></IconBase>
  );
};

export default KeyboardArrowRight;
